import { render } from "./TopInstructors.vue?vue&type=template&id=cc591512&ts=true"
import script from "./TopInstructors.vue?vue&type=script&lang=ts"
export * from "./TopInstructors.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__